<template lang="pug">
  div
    PartnerErrorAlert(:count="partnerErrorCount" @filter-errors="handleFilterErrors")
    .tabla.sombra
      b-row.mb-2(no-gutters style="gap: 10px")
        b-col
          h3 Solicitudes de retiro
        b-col(md="auto")
          b-button(@click="onDownloadExcelDelivery()" block) Exportar Excel
        b-col(md="auto" v-if="this.user.role === 'admin'")
          b-button(@click="$bvModal.show('assign-driver-modal')" block variant="status-approved" :disabled="checkBoxDriver.length === 0") Asignar órdenes
        b-col(md="auto" v-if="this.user.role === 'admin'")
          b-button(@click="showBulkSetPartnerModal = true" block variant="status-approved" :disabled="checkBoxDriver.length === 0") Asignar partner
        b-col(v-if="user.role==='admin'" md="auto")
          b-button(v-b-modal.upload-deliveries-modal @click="" block variant="status-approved" :disabled="false") Subir carga masiva
        b-col(v-if="user.role==='admin'" md="auto")
          b-button(@click="deleteSelectedDeliveries" block variant="status-clear" :disabled="checkBoxDriver.length === 0") Borrar seleccionados
      b-form.mb-2(@submit.stop.prevent="fetchData()")
        b-form-row
          b-col.mb-2(cols="12" md="2")
            b-form-input(v-model="backendFilters.search" placeholder="Buscar...")
          b-col.mb-2(cols="12" md="auto")
            b-form-select(v-model="backendFilters.status" style="min-width: fit-content")
              b-form-select-option(:value="null") Selecciona un Estado
              b-form-select-option(:value="'approved'") Entregados
              b-form-select-option(:value="'in-transit'") En Tránsito
              b-form-select-option(:value="'partial'") Pendientes
              b-form-select-option(:value="'rescheduled'") Reprogramados
              b-form-select-option(:value="'rejected'") Rechazados
              b-form-select-option(:value="'cancelled'") Cancelados
          b-col.mb-2(cols="12" md="3" lg="2" style="max-width: fit-content;")
            div
              b-button.toggle-btn(
                :style="styleDateBtn"
                style="border-radius: 5px 0px 0px 5px;"
                @click="toggleBtn('date')"
              ) Por fecha
              b-button.toggle-btn(
                :style="styleRangeBtn"
                style="border-radius: 0px 5px 5px 0px;"
                @click="toggleBtn('range')"
              ) Por rango
          b-col.mb-2(v-if="backendFilters.isByRange" cols="12" md="3" lg="2" style="min-width: fit-content")
            b-form-datepicker(
              label-no-date-selected="Desde..."
              v-model="backendFilters.startDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              reset-button
              style="min-width: fit-content"
            )
          b-col.mb-2(v-if="backendFilters.isByRange" cols="12" md="3" lg="2" style="min-width: fit-content")
            b-form-datepicker(
              label-no-date-selected="Hasta..."
              v-model="backendFilters.endDate"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              reset-button
              style="min-width: fit-content"
            )
          b-col.mb-2(v-if="!backendFilters.isByRange" cols="12" md="auto")
            b-form-datepicker(
              label-no-date-selected="sin fecha"
              v-model="backendFilters.date"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              reset-button
              style="min-width: fit-content"
            )
          b-col.mb-2(cols="12" md="auto" style="max-width: fit-content;")
            b-select(v-model="dateFilter")
              b-form-select-option(:value="dateFilterEnum.CARGA") Por fecha de carga
              b-form-select-option(:value="dateFilterEnum.CIERRE") Por fecha de cierre
          b-col.mb-2(v-if="canFilterByDriverAndPartner" cols="12" md="auto")
            v-select(
                v-model="backendFilters.driver"
                style="height: 40px; min-width: 188px;"
                :options="driversFilterOptions"
                label="text"
                placeholder="Buscar conductores..."
              )
              span(slot="no-options") No hay conductores disponibles
          b-col.mb-2(cols="12" md="auto")
            v-select(
              v-model="backendFilters.tags__in"
              style="height: 40px; min-width: 170px;"
              :options="deliveryTagsOptions"
              :reduce="tag => tag.value"
              multiple
              placeholder="Selecciona un Tag"
            )
          b-col.mb-2(v-if="canFilterByDriverAndPartner" cols="12" md="auto")
            b-form-select(v-model="backendFilters.partnerCode" :options="partnerOptions" :reduce="partner => partner.value" style="min-height: 40px")
          b-col(cols="12" md="auto")
            b-btn(type="submit" variant="primary" block) Filtrar
      div(ref="tableEl" style="overflow-x: auto; width: 100%;")
        .last-updated.text-muted.small.mb-1 Actualizado {{ lastUpdatedLabel }}
        b-table(
          :fields="fields"
          :items="deliveriesRows"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          @sort-changed="onSortChanged"
        )
          template(#head(assign_driver))
            b-form-checkbox(
              v-model="selectAll"
              @change="toggleSelectAll"
              aria-label="Seleccionar todos"
            )
          template(#cell(assign_driver)="{ item }")
            b-form-checkbox(v-model="item.driverAssigned" @change="asignDriverSelected(item)")
          template(#cell(driverCode)="{item}")
            div {{ item.driver ? `${item.driver.codeDriver}` : '' }}
          template(#cell(driver)="{value}")
            div {{ value ? `${value.name} ${value.lastName}` : '' }}
          template(#cell(date)="{value}")
            div(style="min-width: 80px") {{ value | moment('DD/MM/YYYY') }}
          template(#cell(actions)="{item}")
            .botones-accion
              .material-icons-outlined.btn-icon.mr-2.pt-1(v-if="user.role==='admin'" @click="openEditModal(item)") edit
              .material-icons-outlined.btn-icon.mr-2.pt-1.boton-eliminar(v-if="user.role==='admin'" @click="onDeleteDelivery(item)") delete_outline
              a.text-secondary.material-icons-outlined.btn-icon.mr-2.pt-1(
                :href="`/prueba-entrega/${item.id}`"
                style="cursor: pointer; text-decoration: none; opacity: 0.75;"
              ) file_open
              router-link.text-secondary.material-icons-outlined.btn-icon.mr-2.pt-1(
                v-if="canOpenDriverForm(item)"
                :to="`/completar-envio/${item.id}`"
                v-b-tooltip.hover
                title="Formulario conductor"
                style="text-decoration: none;"
              ) assignment
              b-tooltip(:target="`partner-error-${item.id}`") Error al sincronizar con el partner
              .material-icons-outlined.btn-icon.mr-2.pt-1(v-if="user.role==='admin' && item.partnerDeliverySyncError" :id="`partner-error-${item.id}`" style="color: red;") error
          template(#cell(status)="{value, item}")
            a.text-secondary.status-badge-link(
              target="_blank"
              :href="`/prueba-entrega/${item.id}`"
              style="cursor: pointer; text-decoration: none;"
            )
              StatusBadge(:status="value")
          template(#cell(package.pickedUpByDriver)="{value, item}")
            FlagBadge(
              v-if="!!item.package && getScanStateIsVisible(value)"
              :value="!!value"
              textOn="Escaneado"
              textOff="No escaneado"
              colorOn="var(--status-approved)"
              colorOff="#aaaaaa"
              :clickable="canUpdatePackagesScan"
              :popoverText="getPopoverText(item.package?.pickedUpByDriverUser, item.package?.pickedUpByDriverAt)"
              @click="handleUpdatePackagesScan(item.package, !value, PACKAGE_SCAN_TYPE.SCAN_STORE)"
            )
          template(#cell(package.receivedInWarehouse)="{value, item}")
            FlagBadge(
              v-if="!!item.package && getScanStateIsVisible(value)"
              :value="!!value"
              textOn="Escaneado"
              textOff="No escaneado"
              colorOn="var(--status-approved)"
              colorOff="#aaaaaa"
              :clickable="canUpdatePackagesScan"
              :popoverText="getPopoverText(item.package?.receivedInWarehouseByUser, item.package?.receivedInWarehouseAt)"
              @click="handleUpdatePackagesScan(item.package, !value, PACKAGE_SCAN_TYPE.SCAN_WAREHOUSE)"
            )
          template(#cell(package.inTransit)="{value, item}")
            FlagBadge(
              v-if="!!item.package && getScanStateIsVisible(value)"
              :value="!!value"
              textOn="Escaneado"
              textOff="No escaneado"
              colorOn="var(--status-approved)"
              colorOff="#aaaaaa"
              :clickable="canUpdatePackagesScan"
              :popoverText="getPopoverText(item.package?.inTransitByUser, item.package?.inTransitAt, item.package?.inTransitScanMode)"
              @click="handleUpdatePackagesScan(item.package, !value, PACKAGE_SCAN_TYPE.SCAN_IN_TRANSIT)"
            )
          template(#cell(package.exchangeOrReturn)="{value, item}")
            FlagBadge(
              v-if="!!item.package && getScanStateIsVisible(value)"
              :value="!!value"
              textOn="Escaneado"
              textOff="No escaneado"
              colorOn="var(--status-approved)"
              colorOff="#aaaaaa"
              :clickable="canUpdatePackagesScan"
              :popoverText="getPopoverText(item.package?.exchangeOrReturnByUser, item.package?.exchangeOrReturnAt)"
              @click="handleUpdatePackagesScan(item.package, !value, PACKAGE_SCAN_TYPE.SCAN_EXCHANGE_RETURN)"
            )
          template(#cell(formattedDeliveredAt)="{value}")
            div(style="min-width: 120px") {{value}}
        .d-flex.justify-content-center
          b-pagination.m-auto(
            @change="backendFilters.page = $event, fetchData()"
            :total-rows="countRows"
            :per-page="backendFilters.size"
            aria-controls="my-table"
          )
      b-modal#assign-driver-modal(hide-footer='')
        template(#modal-title='') Conductores
        .d-block
        b-form-group(
          label-for="select-driver"
          invalid-feedback="Este campo es requerido"
        )
          .mb-2 Seleccione Conductor
          v-select(
              v-model="selectedDriver"
              :options="driversAvailableOptions"
              label="text"
              placeholder="Buscar conductores..."
            )
            span(slot="no-options") No hay conductores disponibles
        .d-flex.justify-content-end.mt-2
          b-button(@click="assignDriver" :disabled="!selectedDriver" variant="primary") Asignar

    b-modal(ref="updateDeliveryFormModal" hide-footer :title="`Editando Viaje ${selectedDelivery ? selectedDelivery.drivInCode: ''}`")
      delivery-form(v-if="selectedDelivery" @done="onDoneDeliveryModal" :delivery="selectedDelivery" :editMode="true")
    b-modal#upload-deliveries-modal(title="Importar Envíos" ok-only @hide="isExcelErrors = true, isFinish = false, fetchData()")
      upload-deliveries-from-excel(ref="uploadDeliveryFromExcelForm" @errors="checkExcelErrors" @showSaveBtn="toggleSaveBtn" @done="onDoneDeliveryModal")
      template(#modal-footer="{close}")
        b-button(v-if="!isFinish" :disabled="isExcelErrors" @click="$refs.uploadDeliveryFromExcelForm.onSubmit()") Guardar
    b-modal(v-model="showBulkSetPartnerModal" title="Asignar partner" hide-footer)
      BulkSetPartnerForm(@submit="handleBulkSetPartner")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import DeliveryStateCards from '../delivery/DeliveryStateCards'
import StatusBadge from '../common/StatusBadge'
import DeliveryForm from '../delivery/DeliveryForm'
import MakeToastMixin from '../mixins/MakeToastMixin'
import UploadDeliveriesFromExcel from '../delivery/UploadDeliveriesFromExcel'
import { io } from 'socket.io-client'
import settings from '../../../settings.js'
import html2pdf from 'html2pdf.js'
import Handlebars from 'handlebars'
import moment from 'moment-timezone'
import FlagBadge from '../common/FlagBadge'
import { DELIVERY_TAGS_LIST } from '@/constants/deliveryTags'
import { USER_ROLES, isDriverRole, isViewerRole } from '@/constants/userRoles'
import { PACKAGE_SCAN_TYPE, PACKAGE_SCAN_MODE } from '@/constants/packageScanType'
import BulkSetPartnerForm from '../delivery/BulkSetPartnerForm'
import AppButton from '../UI/AppButton.vue'
import PartnerErrorAlert from '../delivery/PartnerErrorAlert.vue'
import { PARTNERS_TEXT } from '@/constants/partners'
import partnerUtils from '../../utils/partnerUtils'
import useAutoRefresh from '../../services/useAutoRefresh'
import humanizeRelativeTime from '../../services/humanizeRelativeTime'

const SORT_KEY_MAP = {
  date: 'date',
  drivInCode: 'drivInCode',
  internalComment: 'internalComment',
  customerName: 'customerName',
  finalCustomer: 'finalCustomer',
  contactPhone: 'contactPhone',
  address: 'address',
  commune: 'commune',
  observations: 'observations',
  contactEmail: 'contactEmail',
  tagsName: 'tags',
  packageSizeText: 'size',
  bundleQuantity: 'bundleQuantity',
  deliveryAttempts: 'deliveryAttempts',
  partnerText: 'partnerCode',
  driverCode: 'driverCode',
  driver: 'driver',
  status: 'status',
  receiverName: 'receiverName',
  receiverRut: 'receiverRut',
  comment: 'comment',
  'package.pickedUpByDriver': 'package.pickedUpByDriver',
  'package.receivedInWarehouse': 'package.receivedInWarehouse',
  'package.inTransit': 'package.inTransit',
  'package.exchangeOrReturn': 'package.exchangeOrReturn',
  'package.sourceOrderNumber': 'package.sourceOrderNumber',
  'package.labelCode': 'package.labelCode',
  'package.externalId': 'package.externalId',
  formattedDeliveredAt: 'deliveredAt'
}

const SORTABLE_KEYS = Object.keys(SORT_KEY_MAP)

export default {
  mixins: [MakeToastMixin],
  props: {
    deliveryList: Array
  },
  components: {
    DeliveryStateCards,
    StatusBadge,
    vSelect,
    DeliveryForm,
    UploadDeliveriesFromExcel,
    FlagBadge,
    BulkSetPartnerForm,
    AppButton,
    PartnerErrorAlert
  },
  data() {
    const today = moment.tz('America/Santiago').format('YYYY-MM-DD')
    return {
      showBulkSetPartnerModal: false,
      PACKAGE_SCAN_TYPE,
      selectAll: false,
      activeBtn: 'color: #fff; background-color: #3276b1; border-color: #285e8e; transform: translateY(0.8px);',
      inactiveBtn: 'color: #333; background-color: #fff; border-color: #ccc;',
      styleDateBtn: 'color: #fff; background-color: #3276b1; border-color: #285e8e; transform: translateY(0.8px);',
      styleRangeBtn: 'color: #333; background-color: #fff; border-color: #ccc;',
      dateFilter: 'carga',
      dateFilterEnum: {
        CARGA: 'carga',
        CIERRE: 'cierre'
      },
      backendFilters: {
        withPartnerSyncError: null,
        isPickupRequest: true,
        partnerCode: null,
        search: '',
        driver: null,
        page: 1,
        size: 30,
        date: today,
        startDate: null,
        endDate: null,
        status: null,
        isByRange: false,
        minStartDate: null,
        maxStartDate: null,
        maxEndDate: null,
        tags__in: []
      },
      partnerOptions: [
        { text: 'Seleccionar Partner', value: null },
        ...partnerUtils.partnerSelectOptions,
        { text: 'Sin Partner', value: 'NULL' }
      ],
      countRows: 0,
      sortBy: null,
      sortDesc: false,
      driversAvailableOptions: [],
      driversFilterOptions: [],

      selectedDriver: null,
      checkBoxDriver: [],
      driverAssigned: null,
      isExcelErrors: true,
      drivers: [],
      selectedDelivery: null,
      showSaveBtn: false,
      isFinish: false,
      storesToEmit: [],
      driversToEmit: [],
      websocketUrl: settings.baseApi.split('api')[0],
      autoRefresh: null,
      lastUpdatedAt: null,
      lastUpdatedLabel: 'Nunca actualizado',
      lastUpdatedTimer: null
    }
  },
  methods: {
    ...mapActions([
      'listDelivery', 'downloadExcelDelivery', 'getDrivers', 'assignDriverDelivery', 'deleteDelivery', 'deleteMultipleDeliveries',
      'listDriver', 'generatePDF',
      'updatePickupPackage',
      'exportPickupPreLiquidation',
      'updateInTransitPackage',
      'updateExchangeOrReturnPackage',
      'updateReceptionPackage',
      'bulkSetPartner',
      'countPartnerErrorDeliveries'
    ]),
    handleFilterErrors(apply) {
      if (apply) {
        this.backendFilters.withPartnerSyncError = true

      } else {
        this.backendFilters.withPartnerSyncError = null
      }
      this.$nextTick(() => {
        this.fetchData()
      })
    },
    async handleBulkSetPartner(partnerCode) {
      const payload = {
        partnerCode,
        deliveriesIds: this.checkBoxDriver
      }
      try {
        await this.bulkSetPartner(payload)
        this.checkBoxDriver = []
        this.selectAll = false
        this.fetchData()
        this.showBulkSetPartnerModal = false
        this.makeSuccessToast('Partner asignado correctamente')
      } catch (error) {
        this.makeErrorToast('Error al asignar partner')
      }
    },
    canOpenDriverForm(item) {
      // Solo el conductor asignado puede abrir el formulario, y solo si el retiro sigue abierto
      return isDriverRole(this.user.role) &&
        item.driverId === this.user.id &&
        !['approved', 'cancelled'].includes(item.status)
    },
    getScanStateIsVisible(value) {
      // Para las tiendas solo se muestra el estado escaneado es TRUE
      if (this.user.role === USER_ROLES.STORE) {
        return value === true
      }
      return true
    },
    async handleUpdatePackagesScan(_package, value, scan_type) {
      const TITLE_BY_SCAN_TYPE = {
        [PACKAGE_SCAN_TYPE.SCAN_STORE]: 'Escaneado en tienda',
        [PACKAGE_SCAN_TYPE.SCAN_WAREHOUSE]: 'Escaneado en bodega',
        [PACKAGE_SCAN_TYPE.SCAN_IN_TRANSIT]: 'En tránsito',
        [PACKAGE_SCAN_TYPE.SCAN_EXCHANGE_RETURN]: 'Cambio o devolución'
      }
      const ESCANED_TEXT = value ? '"Escaneado"' : ' No Escaneado'
      const ok = await this.$bvModal.msgBoxConfirm(`¿Estás seguro deseas marcar el estado ${TITLE_BY_SCAN_TYPE[scan_type]} como ${ESCANED_TEXT}?`
        , {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar',
          okVariant: 'success',
          cancelVariant: 'danger',
        })
      if (!ok) {
        return
      }

      if (!this.canUpdatePackagesScan) {
        return
      }

      const actions = {
        [PACKAGE_SCAN_TYPE.SCAN_STORE]: this.updatePickupPackage,
        [PACKAGE_SCAN_TYPE.SCAN_WAREHOUSE]: this.updateReceptionPackage,
        [PACKAGE_SCAN_TYPE.SCAN_IN_TRANSIT]: this.updateInTransitPackage,
        [PACKAGE_SCAN_TYPE.SCAN_EXCHANGE_RETURN]: this.updateExchangeOrReturnPackage
      }
      const dataByScanType = {
        [PACKAGE_SCAN_TYPE.SCAN_STORE]: { scan_type, mode: PACKAGE_SCAN_MODE.MANUAL, pickedUpByDriver: value },
        [PACKAGE_SCAN_TYPE.SCAN_WAREHOUSE]: { scan_type, mode: PACKAGE_SCAN_MODE.MANUAL, receivedInWarehouse: value },
        [PACKAGE_SCAN_TYPE.SCAN_IN_TRANSIT]: { scan_type, mode: PACKAGE_SCAN_MODE.MANUAL, inTransit: value },
        [PACKAGE_SCAN_TYPE.SCAN_EXCHANGE_RETURN]: { scan_type, mode: PACKAGE_SCAN_MODE.MANUAL, exchangeOrReturn: value }
      }
      const action = actions[scan_type]
      try {
        const updates = await action({ id: _package.id, data: dataByScanType[scan_type] })
        if (updates) {
          Object.assign(_package, updates)
          this.makeSuccessToast('Paquete actualizado correctamente')
        } else {
          this.makeErrorToast('Error al actualizar el paquete')
        }
      } catch (error) {
        this.makeErrorToast('Error al actualizar el paquete')
      }
    },
    getPopoverText(scannedBy, time, scanMode) {
      if ([USER_ROLES.STORE].includes(this.user.role)) {
        return ''
      }
      let result = ''
      if (scannedBy) result += '<div>' + scannedBy.name + ' ' + scannedBy.lastName + '</div>'
      if (time) result += '<div>' + moment(time).format('DD-MM-YYYY HH:mm') + '</div>'
      if (scanMode) result += '<div>Escaneado: ' + scanMode + '</div>'
      return result
    },
    async toggleMarkPackagesAsScannedById(_package, scan_type, mode) {
      if (!_package.scannedBy) {
        const response = await this.markPackagesAsScannedByIds({ packageIds: [_package.id], scan_type, mode })
        if (response.ok) {
          this.makeSuccessToast(response.data.message)
        }
      } else {
        const response = await this.markPackagesAsScannedByIds({ packageIds: [_package.id], scan_type, mode })
        if (response.ok) {
          this.makeSuccessToast(response.data.message)
        }
      }
    },
    onDownloadExcelDelivery() {
      const params = { ...this.backendFilters }
      if (params.driver) params.driver = params.driver.value
      if (this.user.role === 'admin') {
        this.exportPickupPreLiquidation({ params })
      } else {
        this.downloadExcelDelivery({ params })
      }
    },
    async assignDriver() {
      const response = await this.assignDriverDelivery({ data: { idDelivery: this.checkBoxDriver, driverId: this.selectedDriver } })
      if (response.ok) {
        this.driversToEmit.push(this.selectedDriver.value)
        const driversToEmit = [...new Set(this.driversToEmit)]
        const storesToEmit = [...new Set(this.storesToEmit)]
        this.selectedDriver = null
        this.$bvModal.hide('assign-driver-modal')
        this.makeSuccessToast(response.data.message)
        this.checkBoxDriver = []
        if (this.socket) {
          this.socket.emit('delivery:updated', { update: { drivers: driversToEmit, stores: storesToEmit } })
          this.storesToEmit = []
          this.driversToEmit = []
        }
        this.fetchData()
      }
    },
    async manualScan(packageId, scanMode) {
      const response = await this.manualScanDelivery({ data: { idDelivery: packageId, scanMode } })
      if (response.ok) {
        this.makeSuccessToast(response.data.message)
        this.fetchData()
      }
    },
    async downloadPDF(item) {
      const id = item.id
      this.$bvToast.toast('Generando PDF', {
        variant: 'success',
        solid: true,
        title: 'PDF'
      })
      const response = await this.generatePDF({ id })
      if (response.ok) {
        const responseHtml = await fetch('/templatePDF.html')
        const template = await responseHtml.text()
        const compiledTemplate = Handlebars.compile(template)
        const pdfContainer = document.createElement('div')
        pdfContainer.innerHTML = compiledTemplate(response.data)
        const options = {
          margin: [0.51069, 0.98, 0.51069, 0.89],
          image: { type: 'jpeg', quality: 1.0 },
          jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' },
          html2canvas: {
            letterRendering: true,
            useCORS: true,
            scale: 2
          }
        }

        const pdf = await html2pdf().from(pdfContainer).set(options).output('blob')
        const pdfUrl = URL.createObjectURL(pdf)
        window.open(pdfUrl)

        // Crear un enlace temporal para descargar el PDF
        const link = document.createElement('a')
        link.href = pdfUrl
        link.download = `${item.drivInCode}/${item.address}, ${item.commune}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(pdfUrl) // Liberar memoria
      } else {
        this.$bvToast.toast('No se pudo generar el PDF', {
          variant: 'danger',
          solid: true,
          title: 'PDF'
        })
      }
    },
    async fetchDrivers() {
      const response = await this.listDriver()
      this.drivers = response.data
    },
    asignDriverSelected(item) {
      const index = this.checkBoxDriver.indexOf(item.id)
      if (item.driverAssigned && index === -1) {
        this.checkBoxDriver.push(item.id)
        if (item.customerName) this.storesToEmit.push(item.customerName)
        if (item.driverId) this.driversToEmit.push(item.driverId)
      } else if (!item.driverAssigned && index !== -1) {
        this.checkBoxDriver.splice(index, 1)
        if (item.customerName) {
          const storeToDelete = this.storesToEmit.indexOf(item.customerName)
          if (storeToDelete !== -1) this.storesToEmit.splice(storeToDelete, 1)
        }
        if (item.driverId) {
          const driverToDelete = this.driversToEmit.indexOf(item.driverId)
          if (driverToDelete !== -1) this.driversToEmit.splice(driverToDelete, 1)
        }
      }
    },
    async fetchData(sync = false) {
      if (this.backendFilters.isByRange) {
        this.validateDates()
      }
      const { startDate, date, endDate, ...restBackendFilters } = this.backendFilters
      const params = {
        ...restBackendFilters,
        tags__in: this.backendFilters.tags__in.join(',') || null
      }

      if (this.sortBy && SORT_KEY_MAP[this.sortBy]) {
        params.orderBy = SORT_KEY_MAP[this.sortBy]
        params.orderDirection = this.sortDesc ? 'DESC' : 'ASC'
      }

      if (this.dateFilter === this.dateFilterEnum.CIERRE) {
        params.deliveredAt__gte = startDate
        params.deliveredAt__lte = endDate
        params.deliveredAt = date
      } else if (this.dateFilter === this.dateFilterEnum.CARGA) {
        params.startDate = startDate
        params.endDate = endDate
        params.date = date
      }

      params.driver = this.backendFilters.driver ? this.backendFilters.driver.value : null

      const response = await this.listDelivery({ params })
      this.markUpdated()
      this.countPartnerErrorDeliveries({ params })

      if (response) {
        this.countRows = response.data.count
      }
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.backendFilters.page = 1
      this.fetchData()
    },
    toggleRange() {
      this.backendFilters.isByRange = !this.backendFilters.isByRange

      if (!this.backendFilters.isByRange) {
        this.backendFilters.startDate = null
        this.backendFilters.endDate = null
      } else {
        this.backendFilters.date = new Date().toISOString().slice(0, 10)
      }
    },
    validateDates() {
      if (this.backendFilters.isByRange) {
        // Si falta 1 fecha, la autocompleta con 1 mes más o 1 mes menos según corresponda
        if (this.backendFilters.startDate && !this.backendFilters.endDate) {
          const date = new Date(this.backendFilters.startDate)
          const endDate = new Date(date.setMonth(date.getMonth() + 1))
          this.backendFilters.endDate = endDate.toISOString().slice(0, 10)
        } else if (this.backendFilters.endDate && !this.backendFilters.startDate) {
          const date = new Date(this.backendFilters.endDate)
          const minDate = new Date(date.setMonth(date.getMonth() - 1))
          this.backendFilters.startDate = minDate.toISOString().slice(0, 10)
        }
        // Ordena las fechas startDate como la menor y endDate como la fecha mayor
        if (this.backendFilters.startDate && this.backendFilters.endDate) {
          const startDate = new Date(this.backendFilters.startDate)
          const endDate = new Date(this.backendFilters.endDate)
          if (startDate.getTime() > endDate.getTime()) {
            [this.backendFilters.startDate, this.backendFilters.endDate] = [this.backendFilters.endDate, this.backendFilters.startDate]
          }
        }
      }
    },
    setDateRange(value) {
      this.backendFilters.endDate = null
      if (!value) return

      const date = new Date(value)
      const today = new Date()
      const maxDate = new Date(date.setMonth(date.getMonth() + 1))

      this.backendFilters.minEndDate = value
      if (maxDate.getTime() > today.getTime()) {
        this.backendFilters.maxEndDate = this.backendFilters.date
      } else {
        this.backendFilters.maxEndDate = maxDate.toISOString().slice(0, 10)
      }

      // console.log(this.backendFilters, 'filtros del back')
    },
    toggleBtn(btn) {
      if (btn === 'date') {
        this.styleDateBtn = this.activeBtn
        this.styleRangeBtn = this.inactiveBtn
        if (this.backendFilters.isByRange) {
          this.toggleRange()
        }
      } else {
        this.styleRangeBtn = this.activeBtn
        this.styleDateBtn = this.inactiveBtn
        if (!this.backendFilters.isByRange) {
          this.toggleRange()
        }
      }
    },
    openEditModal(delivery) {
      this.selectedDelivery = delivery
      this.$refs.updateDeliveryFormModal.show()
    },
    async onDeleteDelivery(delivery) {
      const ok = await this.$bvModal.msgBoxConfirm(`¿Está seguro que desea eleminar el viaje ${delivery.drivInCode} de la tienda${delivery.customerName ? ' ' + delivery.customerName : ''}?`)
      if (!ok) return

      const response = await this.deleteDelivery({ id: delivery.id })
      if (response.status === 200) {
        this.makeSuccessToast('El viaje se eliminó correctamente')
        if (this.socket) {
          const updateData = { update: { drivers: [], stores: [] } }
          if (delivery.driverId) updateData.update.drivers.push(delivery.driverId)
          if (delivery.customerName) updateData.update.stores.push(delivery.customerName)
          this.socket.emit('delivery:updated', updateData)
        }
        this.$emit('done')
      } else if (response.status >= 400 && response.status < 500) {
        this.makeDangerToast(response.data.message || 'Error al eliminar el viaje')
      }
      await this.fetchData()
    },
    onDoneDeliveryModal(data) {
      if (!this.isFinish) this.isFinish = true
      this.listDelivery()
      // this.$refs.createDeliveryFormModal.hide()
      this.$refs.updateDeliveryFormModal.hide()
      if (this.socket) {
        this.socket.emit('delivery:updated', { update: data })
      }
      this.$emit('done')
      this.fetchData()
    },
    toggleSaveBtn(value) {
      this.showSaveBtn = value
    },
    checkExcelErrors(value) {
      this.isExcelErrors = value
      console.log('Errores encontrados: ', this.isExcelErrors)
    },
    async initWebsockets() {
      console.log('conectando a websocket')
      this.socket = io(this.websocketUrl)
      this.socket.on('delivery:created', (data) => {
        console.log('Envío creado')
        this.fetchData()
      })
      this.socket.on('delivery:updated', (data) => {
        console.log('Envío actualizado', data || '')
        if (this.user.role === 'admin') this.fetchData()
        if (this.user.role === 'store') {
          if (data.update.stores?.includes(this.user.store.name) || data.update.stores?.includes(this.user.store.storeName)) {
            // this.fetchData()
          }
        }
      })
    },
    handleKeydown(e) {
      if (e.key === 'ArrowLeft') {
        this.$refs.tableEl.scrollBy(-100, 0)
      } else if (e.key === 'ArrowRight') {
        this.$refs.tableEl.scrollBy(100, 0)
      }
    },
    toggleSelectAll() {
      this.deliveries.forEach((item, index) => {
        // Usa $set para garantizar la reactividad
        this.$set(item, 'driverAssigned', this.selectAll)
        this.asignDriverSelected(item) // Mantén la lógica existente para manejar cambios
      })
    },
    async deleteSelectedDeliveries() {
      if (this.checkBoxDriver.length === 0) {
        this.makeDangerToast('No hay elementos seleccionados para eliminar')
        return
      }
      console.log('IDs seleccionados:', this.checkBoxDriver)
      console.log('IDs seleccionados:', this.checkBoxDriver)

      // Asegúrate de que sea un array plano
      const ids = [...this.checkBoxDriver] // O usa Array.from(this.checkBoxDriver)
      console.log('IDs seleccionados:', ids)
      const ok = await this.$bvModal.msgBoxConfirm(
        `¿Está seguro que desea eliminar los ${this.checkBoxDriver.length} envíos seleccionados?`,
        {
          title: 'Confirmar eliminación',
          size: 'md',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (!ok) return

      try {
        // Llamar al endpoint para eliminar múltiples envíos
        const response = await this.$store.dispatch('deleteMultipleDeliveries', { ids })

        if (response && response.status === 200) {
          this.makeSuccessToast('Los envíos seleccionados se eliminaron correctamente')

          // Emitir actualizaciones a través del socket si es necesario
          if (this.socket) {
            const updateData = { update: { drivers: [], stores: [] } }
            this.deliveries.forEach(delivery => {
              if (ids.includes(delivery.id)) {
                if (delivery.driverId) updateData.update.drivers.push(delivery.driverId)
                if (delivery.customerName) updateData.update.stores.push(delivery.customerName)
              }
            })
            this.socket.emit('delivery:updated', updateData)
          }

          // Limpiar selección y recargar datos
          this.checkBoxDriver = []
          await this.fetchData()
        } else {
          this.makeDangerToast(response?.data?.message || 'Error al eliminar los envíos seleccionados')
        }
      } catch (error) {
        this.makeDangerToast('Ocurrió un error al eliminar los envíos seleccionados')
        console.error('Error al eliminar los envíos seleccionados:', error)
      }
    },
    applyChangeOrReturnRowVariant(delivery) {
      if (delivery.package?.exchangeOrReturn) {
        return { ...delivery, '_rowVariant': 'success' }
      }
      return delivery
    },
    markUpdated() {
      this.lastUpdatedAt = new Date()
      this.lastUpdatedLabel = humanizeRelativeTime(this.lastUpdatedAt)
    },
    updateLastUpdatedLabel() {
      this.lastUpdatedLabel = humanizeRelativeTime(this.lastUpdatedAt)
    }
  },
  computed: {
    ...mapGetters(['deliveries', 'store', 'user', 'partnerErrorCount']),
    canFilterByDriverAndPartner() {
      return this.user.role === USER_ROLES.ADMIN || isViewerRole(this.user.role)
    },
    deliveriesRows() {
      return this.deliveries.map((item) => {
        const formatDate = item.deliveredAt ? moment(item.deliveredAt).format('DD-MM-YYYY HH:mm') : ''
        return this.applyChangeOrReturnRowVariant({
          ...item,
          partnerText: PARTNERS_TEXT[item.partnerCode] || item.partnerCode,
          formattedDeliveredAt: formatDate
        })
      })
    },
    deliveryTagsOptions() {
      return [
        { value: 'null', label: 'Sin Tag' },
        ...DELIVERY_TAGS_LIST,
      ]
    },
    canUpdatePackagesScan() {
      return [USER_ROLES.ADMIN, USER_ROLES.VIEWER].includes(this.user.role)
    },
    fields() {
      const fieldsByRole = {
        admin: [
          { label: 'Asignar', key: 'assign_driver' },
          { label: 'Fecha', key: 'date' },
          { label: 'Código', key: 'drivInCode' },
          { label: 'Comentario Interno', key: 'internalComment' },
          { label: 'Tienda', key: 'customerName' },
          { label: 'Destinatario', key: 'finalCustomer' },
          { label: 'Teléfono', key: 'contactPhone' },
          { label: 'Dirección', key: 'address' },
          { label: 'Comuna', key: 'commune' },
          { label: 'Observaciones', key: 'observations' },
          { label: 'Partner', key: 'partnerText' },
          { label: 'Cod. Conductor', key: 'driverCode' },
          { label: 'Conductor', key: 'driver' },
          { label: 'Tags', key: 'tagsName' },
          { label: 'Cantidad de paquetes', key: 'bundleQuantity' },
          { label: 'Estado', key: 'status' },
          { label: 'Recibido por (Nombre)', key: 'receiverName' },
          { label: 'Recibido por (Rut)', key: 'receiverRut' },
          { label: 'Fecha de cierre', key: 'formattedDeliveredAt' },
          { label: 'Comprobante', key: 'actions' }
        ],
        _viewer: [
          { label: 'Fecha', key: 'date' },
          { label: 'Código', key: 'drivInCode' },
          { label: 'Comentario Interno', key: 'internalComment' },
          { label: 'Tienda', key: 'customerName' },
          { label: 'Destinatario', key: 'finalCustomer' },
          { label: 'Teléfono', key: 'contactPhone' },
          { label: 'Dirección', key: 'address' },
          { label: 'Comuna', key: 'commune' },
          { label: 'Observaciones', key: 'observations' },
          { label: 'Partner', key: 'partnerText' },
          { label: 'Cod. Conductor', key: 'driverCode' },
          { label: 'Conductor', key: 'driver' },
          { label: 'Tags', key: 'tagsName' },
          { label: 'Cantidad de paquetes', key: 'bundleQuantity' },
          { label: 'Estado', key: 'status' },
          { label: 'Recibido por (Nombre)', key: 'receiverName' },
          { label: 'Recibido por (Rut)', key: 'receiverRut' },
          { label: 'Fecha de cierre', key: 'formattedDeliveredAt' },
          { label: 'Comprobante', key: 'actions' }
        ],
        get viewer() {
          return this._viewer
        },
        set viewer(value) {
          this._viewer = value
        },
        get warehouse() {
          return this._viewer
        },
        store: [
          { label: 'Fecha', key: 'date' },
          { label: 'Código', key: 'drivInCode' },
          { label: 'Destinatario', key: 'finalCustomer' },
          { label: 'Teléfono', key: 'contactPhone' },
          { label: 'Dirección', key: 'address' },
          { label: 'Comuna', key: 'commune' },
          { label: 'Observaciones', key: 'observations' },
          { label: 'Tags', key: 'tagsName' },
          { label: 'Cantidad de paquetes', key: 'bundleQuantity' },
          { label: 'Estado', key: 'status' },
          { label: 'Recibido por (Nombre)', key: 'receiverName' },
          { label: 'Recibido por (Rut)', key: 'receiverRut' },
          { label: 'Fecha de cierre', key: 'formattedDeliveredAt' },
          { label: 'Comprobante', key: 'actions' }
        ]
      }
      return (fieldsByRole[this.user.role] || []).map(field => ({
        ...field,
        sortable: SORTABLE_KEYS.includes(field.key)
      }))
    }
  },
  async created() {
    this.initWebsockets()
    await this.fetchData()
    this.fetchDrivers()
    if (this.user.role === 'admin' || isViewerRole(this.user.role)) {
      const drivers = await this.getDrivers()
      this.driversFilterOptions.push({ value: 'NULL', text: 'Sin Conductor' })
      // Ordenar conductores por nombre
      drivers.sort((a, b) => a.name.localeCompare(b.name))
      drivers.map(driver => {
        this.driversAvailableOptions.push({ value: driver.id, text: `${driver.name} ${driver.lastName} (${driver.codeDriver})` })
        this.driversFilterOptions.push({ value: driver.id, text: `${driver.name} ${driver.lastName} (${driver.codeDriver})` })
      })
    }
  },
  destroyed() {
    if (!this.socket) return
    this.socket.disconnect()
    console.log('conexión a websocket terminada')
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
    this.autoRefresh = useAutoRefresh({ callback: this.fetchData })
    this.autoRefresh.start()
    this.lastUpdatedTimer = setInterval(this.updateLastUpdatedLabel, 10000)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
    this.autoRefresh?.stop()
    clearInterval(this.lastUpdatedTimer)
  },
  watch: {
    'backendFilters.status': {
      handler(value) {
        this.backendFilters.page = 1
      },
      deep: true
    },
    deliveries: {
      handler(newVal) {
        this.selectAll = newVal.length > 0 && newVal.every(item => item.driverAssigned)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #869099;
  outline: 0;
  box-shadow: 0 0 0 0.2rem #ced4da;
}

.last-updated {
  text-align: right;
}

.botones-accion {
  display: inline-flex;
}

.btn-status-clear.disabled,
.btn-status-clear:disabled {
  color: #fff;
  background-color: rgba(213, 51, 51, 0.8);
  border-color: rgba(213, 51, 51, 0.8);
}

.btn-status-clear {
  color: #fff;
  background-color: rgb(213, 51, 51);
  border-color: rgb(213, 51, 51);
}

.btn-status-clear:hover {
  color: #fff;
  background-color: rgb(187, 39, 39);
  border-color: rgb(177, 36, 36);
}
</style>

<style lang="scss">
.vs__dropdown-toggle {
  height: 38px;
}
</style>
